export const getLocalStorage = (name) => {
  return JSON.parse(localStorage.getItem(`recent-${name}`) || "[]");
};
export const setLocalStorage = (name, images) => {
  localStorage.setItem(`recent-${name}`, JSON.stringify(images.splice(0, 3)));
};
